import { startLoading, stopLoading } from 'components/Loader/LoaderPopup/reducer'
import { setErrorMessage, setPurpleNotification } from 'components/Windows/CentralMessagesList/reducer'
import { downloadPDF } from 'global/helpers'
import { API_LANGUAGE_MAPPING } from 'global/i18n/constants'
import { localeSelector } from 'global/i18n/selectors'
import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import { callApiAsync } from 'services/api/callAPIAsync'
import { downloadTicketsAndVouchers } from './reducer'

function* downloadTicketsSaga(language, ticket_numbers) {
    if (!ticket_numbers || !ticket_numbers.length) {
        return
    }
    const { data: eticketData, error: eticketError } = yield call(callApiAsync, 'eticketGet', {
        language,
        ticket_numbers,
    })

    if (eticketError) {
        console.error(eticketError)
        yield put(setErrorMessage('DOWNLOAD_FAIL'))
        return
    }

    const fileData = eticketData.bytes
    const fileName = eticketData.filename
    downloadPDF(fileData, fileName)
}

function* downloadVouchersSaga(language, voucher_numbers) {
    if (!voucher_numbers || !voucher_numbers.length) {
        return
    }

    const { data: voucherData, error: voucherError } = yield call(callApiAsync, 'evoucherGet', {
        language: language,
        voucher_numbers,
    })

    if (voucherError) {
        console.error(voucherError)
        yield put(setErrorMessage('DOWNLOAD_FAIL'))
        return
    }

    const fileData = voucherData.bytes
    const fileName = voucherData.filename

    if (!fileData) {
        yield put(setErrorMessage('DOWNLOAD_EMPTY_VOUCHERS'))
        return
    }

    if (voucherData.already_used_vouchers.length > 0) {
        yield put(setPurpleNotification('CANT_DOWNLOAD_ALL_VOUCHERS'))
    }

    downloadPDF(fileData, fileName)
}

function* downloadTicketsAndVouchersSaga({ action, payload }) {
    const language = API_LANGUAGE_MAPPING?.[yield select(localeSelector)] ?? ''
    const ticket_numbers = payload.itemsTickets
    const voucher_numbers = payload.itemsVouchers

    yield put(startLoading())

    yield downloadTicketsSaga(language, ticket_numbers)
    yield downloadVouchersSaga(language, voucher_numbers)

    yield put(stopLoading())
}

export default function* downloadSaga() {
    yield all([takeLatest(downloadTicketsAndVouchers.type, downloadTicketsAndVouchersSaga)])
}
